import React, { useEffect } from 'react';
import "../../stepper.css";
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const Stepper = () => {
    const details = useSelector((state) => state.details.details);
    const lastCompletedStep = details?.result?.lastCompletedStep;
    const location = useLocation();
    const route = location.pathname.split('/').pop();
    useEffect(() => {
        console.log(route)
    }, [])
    let currentStep = route === 'Step4DeclarationProperitor' || route === 'Step4DeclarationPartner' ? lastCompletedStep : lastCompletedStep + 1

    return (
        <ul id="progressbar">
            {[1, 2, 3, 4, 5,6,7].map(step => (
                <li
                    key={step}
                    className={`${step <= currentStep ? 'active' : ''}`}
                >
                    Step {step}
                </li>
            ))}
        </ul>
    );
}

export default Stepper;
